import React from 'react';
import { Header } from './';
import { createStyleSheet, useStyleSheet } from '@gopeerproject/ui-kit';
import { Image as ReactNativeImage } from 'react-native';
export const Image = ({ file, onClose }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { file: file, onClose: onClose }),
        React.createElement(ReactNativeImage, { source: { uri: file.data }, 
            // @ts-expect-error translate supports percentages even in react native
            style: styles.background, resizeMode: 'cover' }),
        React.createElement(ReactNativeImage, { source: { uri: file.data }, 
            // @ts-expect-error translate supports percentages even in react native
            style: styles.image, resizeMode: 'center' })));
};
const getStyles = createStyleSheet(() => ({
    background: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: '50%',
        left: '50%',
        // @ts-expect-error translate supports percentages even in react native
        transform: [{ translateX: '-50%' }, { translateY: '-50%' }, { scale: 1.1 }],
        filter: 'blur(10px)',
        opacity: 0.4
    },
    image: { width: '100%', height: '100%' }
}));
//# sourceMappingURL=Image.js.map